'use client';
import { ReactNode, useEffect } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { useStaffAuth } from '@/lib/auth';
import { SharedAppShell, type ShellConfig, type NavItem } from '@tb/ui/AppShell';

const NAV: NavItem[] = [
  {
    label: 'Обзор',
    icon: 'grid',
    children: [
      { href: '/', label: 'Дашборд', match: '^/$', icon: 'grid' },
    ],
  },
  {
    label: 'Клиенты',
    icon: 'building',
    children: [
      { href: '/companies', label: 'Компании', match: '^/companies', icon: 'building' },
      { href: '/users', label: 'Пользователи', match: '^/users', icon: 'users' },
    ],
  },
  {
    label: 'Контент',
    icon: 'puzzle',
    children: [
      { href: '/tests', label: 'Тесты', match: '^/tests', icon: 'puzzle' },
      { href: '/articles', label: 'Статьи', match: '^/articles', icon: 'book' },
      { href: '/programs', label: 'Программы', match: '^/programs', icon: 'rocket' },
    ],
  },
  {
    label: 'Команда',
    icon: 'shield',
    children: [
      { href: '/staff', label: 'Сотрудники', match: '^/staff', icon: 'shield' },
    ],
  },
  {
    label: 'Мониторинг',
    icon: 'alert',
    children: [
      { href: '/logs', label: 'Логи ошибок', match: '^/logs', icon: 'alert' },
    ],
  },
  {
    label: 'Финансы',
    icon: 'chart',
    children: [
      { href: '/billing', label: 'Биллинг', match: '^/billing', icon: 'chart' },
    ],
  },
];

export default function AppShell({ children }: { children: ReactNode }) {
  const router = useRouter();
  const pathname = usePathname();
  const { staff, loading, logout } = useStaffAuth();

  const isPublic = pathname === '/login';

  useEffect(() => {
    if (!isPublic && !loading && !staff) {
      router.replace('/login');
    }
  }, [isPublic, loading, staff, router]);

  if (isPublic) return <>{children}</>;

  if (loading || !staff) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-sm text-muted-foreground">Загрузка…</div>
      </div>
    );
  }

  const config: ShellConfig = {
    brandLabel: 'Admin',
    nav: NAV,
    userEmail: staff.email,
    onLogout: () => {
      logout();
      router.replace('/login');
    },
  };

  return <SharedAppShell config={config}>{children}</SharedAppShell>;
}
